import { render, staticRenderFns } from "./GroupCreatedFileScroll.vue?vue&type=template&id=1130dc45&scoped=true"
import script from "./GroupCreatedFileScroll.vue?vue&type=script&lang=js"
export * from "./GroupCreatedFileScroll.vue?vue&type=script&lang=js"
import style0 from "./GroupCreatedFileScroll.vue?vue&type=style&index=0&id=1130dc45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130dc45",
  null
  
)

export default component.exports